<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="flex h-16 justify-between items-center">
      <div class="flex">
        <!-- Hamburger Icon -->
        <button
          @click="$emit('toggle-sidebar')"
          class="p-2 rounded-md text-gray-600 hover:text-gray-900 focus:outline-none"
        >
          <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
          <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <div class="flex items-center">
        <!-- User info display (hidden on mobile) -->
        <div
          v-if="isAuthenticated && userInfo"
          class="hidden sm:flex sm:items-center mr-4"
        >
          <div class="text-right">
            <div class="text-sm font-medium text-gray-900">
              {{ userInfo.fullName }}
            </div>
            <div class="text-sm text-gray-500">{{ userInfo.email }}</div>
          </div>
        </div>

        <!-- Profile dropdown (responsive for both mobile and desktop) -->
        <div class="ml-3 sm:ml-6">
          <Menu as="div" class="relative">
            <div>
              <MenuButton
                class="relative flex rounded-full bg-white text-sm focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-2"
              >
                <span class="absolute -inset-1.5" />
                <span class="sr-only">Open user menu</span>
                <img
                  class="h-8 w-8 rounded-full"
                  src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                  alt=""
                />
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition ease-out duration-200"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems
                class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none py-1"
              >
                <!-- Profile Menu Item -->
                <MenuItem v-if="isAuthenticated" v-slot="{ active }">
                  <button
                    @click="goToProfile"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-all duration-200',
                    ]"
                  >
                    <UserIcon class="w-5 h-5" />
                    Profile
                  </button>
                </MenuItem>

                <!-- Conditionally render "Settings" if the user is an organization admin -->
                <MenuItem v-if="isOrganizationAdmin" v-slot="{ active }">
                  <button
                    @click="goToOrganizationSettings"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-all duration-200',
                    ]"
                  >
                    <Cog6ToothIcon class="w-5 h-5" />
                    Settings
                  </button>
                </MenuItem>

                <MenuItem v-if="isAuthenticated" v-slot="{ active }">
                  <button
                    @click="handleSignOut"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-all duration-200',
                    ]"
                  >
                    <ArrowRightOnRectangleIcon class="w-5 h-5" />
                    Logout
                  </button>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import {
  UserIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/vue/24/solid";
import { isAuthenticated, getUserRoles, getUserInfo } from "../services/token";

export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Bars3Icon,
    XMarkIcon,
    UserIcon,
    Cog6ToothIcon,
    ArrowRightOnRectangleIcon,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageUrl: require("@/assets/images/gpolls.png"),
    };
  },
  computed: {
    roles() {
      return getUserRoles();
    },
    userInfo() {
      return getUserInfo();
    },
    isOrganizationAdmin() {
      if (this.roles && this.roles[0].includes("ORGANIZATION_ADMIN")) {
        return true;
      }
      return false;
    },
    isAuthenticated() {
      return isAuthenticated();
    },
  },
  methods: {
    handleSignOut() {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("expirationTime");
      this.$router.push({ path: "/login" });
    },
    goToOrganizationSettings() {
      this.$router.push({ path: "/organization-settings" });
    },
    goToProfile() {
      // TODO: Implement profile navigation when profile page is created
      console.log("Navigate to profile");
    },
  },
};
</script>
